import React, {Component} from 'react';
const { connect } = require('react-redux');

import {t, nt} from 'l10n';

import ProfileLink from 'components/ProfileLink';
import Pagination from 'components/Pagination';
import Loading from 'components/Loading';

import {getGenerousUsers} from 'reducers/main';

import 'sass/index-generous-users.scss';

const GENEROUS_USERS_COUNT = 15;

class GenerousUsersIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            page: props.generousUsers.page
        }
    }

    componentDidMount() {
        let {dispatch, generousUsers} = this.props;
        let {page} = this.state;

        if (!generousUsers.list) {
            this.constructor.fetchData({dispatch, params: {page}});
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.page !== prevState.page) {
            let {dispatch} = this.props;

            this.constructor.fetchData({dispatch, params: {page: this.state.page}});
        }
    }

    static fetchData({dispatch, params}) {
        const {page} = params;

        const reducerParams = {
            page,
            limit: GENEROUS_USERS_COUNT
        };

        return dispatch(getGenerousUsers(reducerParams));
    }

    render() {
        let {generousUsers} = this.props;
        let {list, totalCount, isLoading} = generousUsers;

        let {page} = this.state;

        if (!list) {
            return <Loading/>;
        }

        return (
            <div className="generous-users-index">
                <div className="content">
                    <div className="info">
                        <div className="left">
                            <ul>
                                <li>{t('List of members who have given the greatest number of virtual gifts and tokens over the last 60 days.')}</li>
                                <li>{t('To be rewarded with a medal, you must give virtual gifts or tokens to other users according to the following scale:')}</li>
                                <li>Cocarde bleue <span className="icon medal-blue" /> : 250 jetons.</li>
                                <li>Cocarde rouge <span className="icon medal-red" /> : 500 jetons.</li>
                                <li>Cocarde or <span className="icon medal-gold" /> : 1000 jetons.</li>
                                <li>Coupe or <span className="icon cup-gold" /> : 5000 jetons.</li>
                                <li>&nbsp;</li>
                                <li>{t('Please note, virtual gifts given anonymously are not counted. You must display your username to "all" when giving a gift.')}</li>
                                <li>{t('Only tokens you have purchased are counted.')}</li>
                            </ul>
                        </div>
                    </div>
                    {isLoading && <Loading/>}
                    <div className="list ui-responsive-grid">
                        {list.map((user, index) =>
                            <GenerousUserListItem generousUser={user} key={index}/>
                        )}
                    </div>
                    <div className="page-list">
                        <Pagination
                            itemsPerPage={GENEROUS_USERS_COUNT}
                            totalCount={totalCount}
                            currentPage={page}
                            onClick={(page) => this.setState({page})}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    (state) => ({
        generousUsers: state.main.generousUsers
    }),
    null
)(GenerousUsersIndex);

class GenerousUserListItem extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };

    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    render() {
        let {generousUser} = this.props;


        let bg = "";

        if(generousUser.biggest_tip < 5) {
            bg = "";
        } else if(generousUser.biggest_tip < 10) {
            bg = "bg1";
        } else if(generousUser.biggest_tip < 20) {
            bg = "bg2";
        } else if(generousUser.biggest_tip < 50) {
            bg = "bg3";
        } else if(generousUser.biggest_tip < 100) {
            bg = "bg4";
        } else if(generousUser.biggest_tip < 200) {
            bg = "bg5";
        } else if(generousUser.biggest_tip < 500) {
            bg = "bg6";
        } else if(generousUser.biggest_tip < 1000) {
            bg = "bg7";
        } else {
            bg = "bg8";
        }

        return (
            <div>
                <div className="block-favourite">
                    <ProfileLink user={generousUser} className="img">
                        <img src={generousUser.avatar_url} alt={generousUser.nick}/>
                    </ProfileLink>
                    <div className="text">
                        <ProfileLink user={generousUser}>
                            <span className={"token " + bg} title={t('The biggest tip of last 60 days')}>{generousUser.biggest_tip}</span>
                        </ProfileLink>
                        <div className="author-name-generous-users">
                            <ProfileLink user={generousUser}/>
                        </div>
                        <div className="generosity-rank">
                            <span className={'icon-generosity rank' + generousUser.generosity_rank} />
                            {nt('%1 jeton', '%1 jetons', generousUser.tokens)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/index/GenerousUsersIndex.js